import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../config/api";
import { BASE_API } from "../../../constants/apiUrls";
import { toast } from "../../../lib/toast";
import {
  CommonOthers,
  ErrorMessage,
  GetCommonData,
  Params,
  PostRequest,
} from "../../../types";
import {
  CreateDonation,
  GetDonationData,
  GetDonationDataParams,
} from "../../../types/donation/donation";
import { handleApiError } from "../../../utils/errorHandler";

// create
export const createDonationAsync = createAsyncThunk<
  null,
  PostRequest<CreateDonation, CommonOthers>
>(
  "admin/createDonation",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.post(BASE_API.createDonation, data, {
        headers: {},
      });

      reRender(true);
      toast("success", "Donation create successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      handleApiError(error, "Donation create fail");
      return rejectWithValue(error);
    }
  }
);

// get all
export const getAllDonationAsync = createAsyncThunk<
  GetCommonData<GetDonationData>,
  Params<GetDonationDataParams>,
  {
    rejectValue: ErrorMessage;
  }
>("admin/getAllDonation", async ({ params }, { rejectWithValue }) => {
  const { ...rest } = params as GetDonationDataParams;

  try {
    const data = await AXIOS.get(BASE_API.getAllDonation, {
      params: { ...rest },
      headers: {},
    });

    return {
      data: data.data?.data,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Get Donation fail");
    return rejectWithValue(error);
  }
});
